import React from 'react';
import { Row, Col, Card, Table } from 'reactstrap';
import CodeBlock from '../CodeBlock';
import { HashLink as Link } from 'react-router-hash-link';

function ApplicationSection() {
    return (
        <section id="applications">
            <Row>
                <Col>
                    <h3>Applications endpoint (/candidate/applications/&#123;candidateId&#125;)</h3>
                    <p>
                        <code>GET</code> request <code>/Candidate/applications/123456</code> can be used with{' '}
                        <Link to="#applicationssince">
                            <code>applicationsSince</code>
                        </Link>{' '}
                        parameter.
                    </p>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/candidate/applications/123456?applicationsSince=01/01/2016' \\\n-H 'authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto' \\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`Authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/json; charset=utf-8\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`[\n\t{\t\t\n\t\t"NormalisedJobTitle": "senior account manager",\n\t\t"Location": "City of London, London",\n\t\t"ApplyDate": "08/04/2021 07:11:50"\n\t},…\n]`}
                        </CodeBlock>
                    </Card>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>NormalisedJobTitle</td>
                                <td>string</td>
                                <td>Standard job title calcualted by TotalJobs.</td>
                            </tr>
                            <tr>
                                <td>Location</td>
                                <td>string</td>
                                <td>Location of application.</td>
                            </tr>
                            <tr>
                                <td>ApplyDate</td>
                                <td>date</td>
                                <td>Date of application.</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </section>
    )
}

export default ApplicationSection
